import { SetFullScreenModal } from '@customTypes/setFullScreenModal'
import CustomerAddressCreateForm from '@features/account/components/CustomerAddressCreateForm/CustomerAddressCreateForm'
import CustomerAddressFormUpdate from '@features/account/components/CustomerAddressUpdateForm/CustomerAddressUpdateForm'
import { selectModalProps } from '@redux/modalSlice'
import { useAppSelector } from '@redux/store'
import { FC, useEffect } from 'react'
import s from './AddressModal.module.scss'

type Props = {}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type AddressModalProps = Props & NativeAttrs & SetFullScreenModal

const AddressModal: FC<AddressModalProps> = ({ setFullScreen }) => {
  const modalProps = useAppSelector(selectModalProps)
  const { data } = modalProps

  useEffect(() => {
    if (setFullScreen) {
      setFullScreen('mobile')
    }
  }, [])

  return (
    <div className={s.root}>
      <div className={s.section}>
        <div className={s.headline}>
          {data.type === 'update' ? 'EDIT ADDRESS' : 'NEW ADDRESS'}
        </div>
      </div>

      {data.type === 'update' ? (
        <CustomerAddressFormUpdate
          customer={data?.customer}
          address={data?.address ?? ''}
          isDefaultBilling={data?.isDefaultBilling}
          isDefaultShipping={data?.isDefaultShipping}
        />
      ) : (
        <CustomerAddressCreateForm />
      )}
    </div>
  )
}

export default AddressModal
